import { DatePickerStyles } from "../types";
import { defaultThemeStyles } from "./defaultThemeStyles";

export const datePickerDefaultStyles: DatePickerStyles = {
  CalendarBackgroundColour: defaultThemeStyles.CalendarBackgroundColour,
  CalendarBorderColour: defaultThemeStyles.CalendarBorderColour,
  CalendarBorderRadius: defaultThemeStyles.CalendarBorderRadius,
  CalendarMonthDayTextColour: defaultThemeStyles.CalendarMonthDayTextColour,
  CalendarDayTextColour: defaultThemeStyles.CalendarDayTextColour,
  CalendarDayBackgroundColour: defaultThemeStyles.CalendarDayBackgroundColour,
  CalendarDayBorderRadius: defaultThemeStyles.CalendarDayBorderRadius,
  CalendarSelectedTextColour: defaultThemeStyles.CalendarSelectedTextColour,
  CalendarSelectedBackgroundColour:
    defaultThemeStyles.CalendarSelectedBackgroundColour,
};
